// src/apis/notificationService.js

import { authApiService } from './authService';

class NotificationService {
  /**
   * Get notifications for current user
   */
  async getNotifications({ isRead, type, page = 1, limit = 50 } = {}) {
    try {
      const params = { page, limit };
      if (isRead !== undefined) params.isRead = isRead;
      if (type) params.type = type;

      const response = await authApiService.get('/notifications', { params });
      
      // Your backend returns: { statusCode, body: { message, data: { notifications, pagination } } }
      if (response.data?.statusCode) {
        return {
          success: response.data.statusCode,
          data: response.data.body?.data || { notifications: [], pagination: {} },
          message: response.data.body?.message || ''
        };
      }
      
      // Fallback
      return {
        success: true,
        data: response.data?.data || { notifications: [], pagination: {} },
        message: 'Success'
      };
    } catch (error) {
      console.error('Error fetching notifications:', error);
      throw error;
    }
  }

  /**
   * Get unread notification count
   */
  async getUnreadCount(type = null) {
    try {
      const params = type ? { type } : {};
      const response = await authApiService.get('/notifications/unread-count', { params });
      
      if (response.data?.statusCode) {
        return {
          success: response.data.statusCode,
          data: response.data.body?.data || { unreadCount: 0 },
          message: response.data.body?.message || ''
        };
      }
      
      return {
        success: true,
        data: response.data?.data || { unreadCount: 0 },
        message: 'Success'
      };
    } catch (error) {
      console.error('Error fetching unread count:', error);
      throw error;
    }
  }

  /**
   * Mark a single notification as read
   */
  async markAsRead(notificationId) {
    try {
      const response = await authApiService.patch(`/notifications/${notificationId}/read`);
      
      if (response.data?.statusCode) {
        return {
          success: response.data.statusCode,
          data: response.data.body?.data || {},
          message: response.data.body?.message || ''
        };
      }
      
      return {
        success: true,
        data: response.data?.data || {},
        message: 'Success'
      };
    } catch (error) {
      console.error('Error marking notification as read:', error);
      throw error;
    }
  }

  /**
   * Mark all notifications as read
   */
  async markAllAsRead(type = null) {
    try {
      const body = type ? { type } : {};
      const response = await authApiService.patch('/notifications/mark-all-read', body);
      
      if (response.data?.statusCode) {
        return {
          success: response.data.statusCode,
          data: response.data.body?.data || {},
          message: response.data.body?.message || ''
        };
      }
      
      return {
        success: true,
        data: response.data?.data || {},
        message: 'Success'
      };
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
      throw error;
    }
  }

  /**
   * Delete a notification
   */
  async deleteNotification(notificationId) {
    try {
      const response = await authApiService.delete(`/notifications/${notificationId}`);
      
      if (response.data?.statusCode) {
        return {
          success: response.data.statusCode,
          data: response.data.body?.data || {},
          message: response.data.body?.message || ''
        };
      }
      
      return {
        success: true,
        data: response.data?.data || {},
        message: 'Success'
      };
    } catch (error) {
      console.error('Error deleting notification:', error);
      throw error;
    }
  }
}

export const notificationService = new NotificationService();